// submit form
document.querySelector("#footerBodyGridNewsletterForm")?.addEventListener("submit", async function (e) {
    e.preventDefault();

    // send form data
    let response = await fetch(`${root}/newsletter.php`, {
        method: 'POST',
        body: new FormData(this)
    })
        .then(response => response.json())

    // check for error
    if (response.error) {
        alert(response.error);
        return;
    }

    document.querySelector("#footerBodyGridNewsletterTitle").textContent = `Thank you for subscribing!`;
    document.querySelector("#footerBodyGridNewsletterForm").remove();
});